// The name shown for an author (PersonRef {id, username, full_name} of the backend): the full
// name if the account has one, else the username. An author the server could not name (null)
// shows as "an unknown author".
export function authorName(person) {
  if (!person) return "an unknown author";
  return person.full_name || person.username;
}

// The edit hint for something a member wrote (a study's dataset): its author, the
// project's curators and admins may edit it (unio/deps.py).
export function editedBy(person) {
  return `edited by ${authorName(person)} and the project's curators`;
}
